import React from 'react';
import { Link } from '@tanstack/react-router';
import { useDatasetsQuery, useTablesQuery } from '../api/queries';
import { useAccountStore } from '../lib/account-store';

export default function TableDataScreen() {
  const account = useAccountStore(state => state.account);
  const [selectedDataset, setSelectedDataset] = React.useState<string | undefined>(
    account?.dataset
  );
  const { data: datasets = [], isLoading: datasetsLoading } = useDatasetsQuery(Boolean(account));
  const datasetId = selectedDataset ?? datasets[0]?._id;
  const { data: tableList } = useTablesQuery(datasetId);
  const tables = tableList?.items ?? [];

  React.useEffect(() => {
    if (!selectedDataset && datasetId) setSelectedDataset(datasetId);
  }, [datasetId, selectedDataset]);

  return (
    <div className="space-y-6">
      <section className="rounded-lg border border-pale-grey-three bg-white p-4">
        <label className="text-xs font-semibold uppercase text-slate">Dataset</label>
        <select
          className="mt-1 w-full rounded-md border border-pale-grey-three px-3 py-2 text-sm"
          value={datasetId ?? ''}
          disabled={datasetsLoading}
          onChange={event => setSelectedDataset(event.target.value)}
        >
          {datasets.map(dataset => (
            <option key={dataset._id} value={dataset._id}>
              {dataset.name ?? dataset._id}
            </option>
          ))}
        </select>
      </section>

      <section className="grid gap-4 md:grid-cols-2">
        {tables.length ? (
          tables.map(table => (
            <Link
              key={table._id}
              to="/data/table/$tableId"
              params={{ tableId: table._id }}
              className="rounded-lg border border-pale-grey-three bg-white p-4 text-sm text-charcoal-grey shadow-sm hover:border-cool-blue"
            >
              <p className="text-xs uppercase text-slate">Tabla</p>
              <p className="mt-1 text-base font-semibold">{table.name ?? table._id}</p>
            </Link>
          ))
        ) : (
          <div className="rounded-lg border border-pale-grey-three bg-white p-4 text-sm text-slate">
            No hay tablas disponibles para este dataset.
          </div>
        )}
      </section>
    </div>
  );
}
